module.exports = __webpack_public_path__ + "saira-semibold-webfont.e6a03d4ec14a739debbe.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-semibold-webfont.eot
// module id = ../../../../../src/assets/fonts/saira-semibold-webfont.eot
// module chunks = styles